(() => {
  const panels = document.querySelectorAll('[data-vyrx-offer-deadline]');

  if (!panels.length) {
    return;
  }

  const SECOND_MS = 1000;
  const MINUTE_MS = 60 * SECOND_MS;
  const HOUR_MS = 60 * MINUTE_MS;
  const DAY_MS = 24 * HOUR_MS;

  const formatCountdown = (remainingMs) => {
    const safeRemaining = Math.max(0, remainingMs);
    const days = Math.floor(safeRemaining / DAY_MS);
    const hours = Math.floor((safeRemaining % DAY_MS) / HOUR_MS);
    const minutes = Math.floor((safeRemaining % HOUR_MS) / MINUTE_MS);
    const seconds = Math.floor((safeRemaining % MINUTE_MS) / SECOND_MS);
    const segments = [];

    if (days > 0) {
      segments.push(`${days}D`);
    }

    segments.push(`${hours}H`);
    segments.push(`${minutes}M`);
    segments.push(`${seconds}S`);

    return `${segments.join(' ')} LEFT`;
  };

  panels.forEach((panel) => {
    const offers = panel.querySelectorAll('[data-vyrx-offer]');
    const countdown = panel.querySelector('[data-vyrx-offer-countdown]');
    const deadlineValue = panel.getAttribute('data-vyrx-offer-deadline');
    const deadline = deadlineValue ? new Date(deadlineValue).getTime() : NaN;

    if (!offers.length || !countdown || Number.isNaN(deadline)) {
      return;
    }

    let intervalId = null;

    const update = () => {
      const remainingMs = deadline - Date.now();

      if (remainingMs > 0) {
        offers.forEach((offer) => {
          offer.hidden = false;
        });
        countdown.textContent = formatCountdown(remainingMs);
        return;
      }

      offers.forEach((offer) => {
        offer.hidden = true;
      });

      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
    };

    update();

    if (!intervalId) {
      intervalId = window.setInterval(update, SECOND_MS);
    }
  });
})();
